export default __webpack_public_path__ + "static/media/boss_dvalin_plume.448e62da.png";